export enum MyChartFilterSituationEnumData {
  active = 'patient.active',
  inactive = 'patient.my-chart.inactive',
  released = 'patient.my-chart.released',
  notReleased = 'patient.my-chart.not-released',
  activeCode = 'A',
  inactiveCode = 'I',
  notReleasedCode = 'N',
  releasedCode = 'R'
}
